var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmericanExpress = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.39 17.8135L28.0033 16.2668L26.5633 17.8135H23.7367H17.6567V10.6135H14.83L18.35 2.56017H21.7633L22.99 5.3335V2.56017H27.2567L28.0033 4.64017L28.75 2.56017H32.0033C32.0033 1.14632 30.8576 0.000151332 29.4438 0.000136946C21.108 5.2132e-05 12.3788 0.000625213 4.00025 0.000256564C1.79098 0.000159358 0 1.79107 0 4.00034V15.9997C0 18.209 1.79104 19.9999 4.00035 19.9998C12.504 19.9993 21.3689 20 29.817 20.0002C31.0247 20.0002 32.0033 19.0212 32.0033 17.8135H29.39Z",
    fill: "#0071CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7634 16.9602H32.0034L29.0701 13.8135L32.0034 10.7202H29.8167L27.9501 12.7469L26.1367 10.7202H23.8967L26.8834 13.8669L23.8967 16.9602H26.0834L27.9501 14.9335L29.7634 16.9602Z",
    fill: "#0071CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3234 15.5202V14.5602H23.8434V13.1202H20.3234V12.1602H23.8967V10.7202H18.6167V16.9602H23.8967V15.5202H20.3234Z",
    fill: "#0071CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3501 9.81362H32.0034V3.5736L29.3901 3.57362L28.0034 7.46695L26.5634 3.57362H23.8967V9.81362H25.6034V5.44029L27.2034 9.81362H28.6967L30.3501 5.44029V9.81362Z",
    fill: "#0071CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1768 3.57349H18.9901L16.2168 9.81349H18.0835L18.6168 8.58682H21.4968L22.0301 9.81349H23.9501L21.1768 3.57349ZM19.2035 7.14682L20.0568 5.12015L20.9101 7.14682H19.2035Z",
    fill: "#0071CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4565 13.6534L32.0032 15.3601V11.9468L30.4565 13.6534Z",
    fill: "#0071CE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmericanExpress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AmericanExpress.f2ad9ccf2c21abc6362643a0bd3b5ab1.svg";